var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRelaysFuses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 11C19.6 11 20 10.6 20 10C20 9.5 19.6 9 19 9H18V7H19C19.6 7 20 6.6 20 6C20 5.5 19.6 5 19 5H18V4C18 2.9 17.1 2 16 2H15V1C15 0.5 14.6 0 14 0C13.5 0 13 0.4 13 1V2H11V1C11 0.5 10.6 0 10 0C9.4 0 9 0.4 9 1V2H7V1C7 0.5 6.6 0 6 0C5.4 0 5 0.4 5 1V2H4C2.9 2 2 2.9 2 4V5H1C0.4 5 0 5.4 0 6C0 6.5 0.4 7 1 7H2V9H1C0.4 9 0 9.4 0 10C0 10.5 0.4 11 1 11H2V13H1C0.4 13 0 13.4 0 14C0 14.5 0.4 15 1 15H2V16C2 17.1 2.9 18 4 18H5V19C5 19.5 5.4 20 6 20C6.6 20 7 19.6 7 19V18H9V19C9 19.5 9.4 20 10 20C10.6 20 11 19.6 11 19V18H13V19C13 19.5 13.4 20 14 20C14.5 20 15 19.6 15 19V18H16C17.1 18 18 17.1 18 16V15H19C19.6 15 20 14.6 20 14C20 13.5 19.6 13 19 13H18V11H19ZM16 16H4V4H16V16Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelaysFuses);
export default __webpack_public_path__ + "static/media/relays-fuses.afbb1a8bf5f8be8f4a9a79ac03490423.svg";
export { ForwardRef as ReactComponent };